import clsx from 'clsx'

export function FilterInputCheckbox({ values, onFilter, name, split }) {
  return values.map((item) => {
    return (
      <div className={clsx('mb-6 flex h-6 items-center gap-2', split ? 'min-w-[50%]' : 'w-full')} key={item.value}>
        <input
          id={item.value}
          type="checkbox"
          name={name}
          checked={item.checked}
          disabled={item.disabled}
          onClick={() => onFilter(item.value)}
          className="field-checkbox peer"
        />
        <label
          for={item.value}
          className="paragraph-sm text-neturals-secondary-grey peer-disabled:text-neutrals-medium-grey"
        >
          {item.label}
        </label>
        {!item.count ? null : <p className="paragraph-sm text-neutrals-secondary-grey">({item.count})</p>}
      </div>
    )
  })
}
